import { useEffect, useState } from "react";
import PageHeading from "../components/PageHeading.component";
import Select from 'react-select'
import '../styles/TicketTemplates.css';

import EventsService from "../services/events.service";
import AuthService from "../services/auth.service";
import TicketTemplatesService from "../services/tickettemplates.service";

function TicketTemplates() {
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const [physicalHtml, setphysicalHtml] = useState('');
    const [rawHtml, setrawHtml] = useState('');
    const [eventTickets, setEventTickets] = useState([]);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [ticketConfig, setTicketConfig] = useState({
        showPresentText: true,
        overPresentText: '',
        showEventName: true,
        overEventName: '',
        showEventLocation: true,
        overEventLocation: '', 
        showEventDateTime: true,
        overEventDateTime: '',
        showCustomerName: true,
        overCustomerName: '',
        showSeatLabel: true,
        overSeatLabel: '',
        showTicketCat: true,
        overTicketCat: '',
        showTicketPrice: true,
        overTicketPrice: '',
        showOrderDateTime: true,
        showQRCode: true,
        overTicketNote: '',
    });

    useEffect(() => {
        AuthService.checklogin()
        .then(user => {
            if(user!=null) {
                getAllEvents();
                setIsLoggedIn(true);
            } else {
                setIsLoggedIn(false);
                window.location.href='/login';
            }
        })
        .catch((err) => {
            setIsLoggedIn(false);
            console.log(err);
            window.location.href='/login';
        });
    }, [])

    useEffect(() => {
        if(isLoggedIn==false) {
            window.location.href='/login';
        }
    } , [isLoggedIn]);    

    const getAllEvents = () => {
        EventsService.getAllEvents()
        .then((res) => {
            // console.log({res});
            setEvents(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }
    
    const eventChanged = (event) => {
        setSelectedEvent(event);
        setEventTickets([]);
        setSelectedTicket(null);
        TicketTemplatesService.getEventTickets(event.value)
        .then(resp => {
            console.log({resp});
            setEventTickets(resp.data);
        })
        .catch(err => {
            console.log({err});
        });
        var html = `<html><head><meta charset="UTF-8"><link href="https://fonts.googleapis.com/css?family=Arial:300,400,700" rel="stylesheet" type="text/css"><style type="text/css">body{background-image: url("assets/pticket-background.jpg");background-size: 564px 192px;background-repeat: no-repeat;background-color: #fff;font-family: Arial, Helvetica, sans-serif;}</style></head><body style=" width: 535px;height:192px;margin:0px;padding:0px;float:left"><div style="width:564px;height:192px;float:left;font-weight:bold"><div style="width: 135px;float: left;padding: 60px 0 0 15px;"><div><div style="font-size:9px;overflow-wrap:break-word;margin-top:2px;">[customer name]</div><div style="font-size:9px;overflow-wrap:break-word;margin-top:2px;">[order datetime]</div><div style="font-size:10px;overflow-wrap:break-word;margin-top: 8px;">[event name]</div><div style="font-size:9px;overflow-wrap:break-word;margin-top: 8px;">[event datetime]</div><div style="font-size:10px;overflow-wrap:break-word;">[event location]</div></div></div><div style="width:15px;height:192px;float:left;"></div><div style="width:320px;height:192px;float:left;"><div style="text-align:center;color: #000;font-size: 10px; margin-top:10px;margin-left: 70px;">[producer presents]</div><div style="text-align:center;font-size: 13px;color: #000;text-transform:uppercase;height: 32px;margin-left: 70px;">[event name]</div><div style="text-align:center;height: 109px;"><div style="width: 237px;height: 56px;float: left;margin-left: 10px;display: table;"><div style=" display: table-cell; vertical-align: middle;padding: 1px;font-size: 13px;"><div style="padding: 0px 15px;text-align:center">[event location]</div><div style="padding: 0px 5px;text-align:center">[event datetime]</div></div></div><div style="float: left;"><img style="width: 58px;height: 60px;padding-left:8px;" src="http://otayo.com/phantom/QRcode.php?id=0000030513"></div><div style="height: 46px;margin-left: 10px;margin-top: 7px;float: left;font-size: 13px;"><div style="text-align:center;width: 95px;float:left;display: table;height: 46px;"><div style=" display: table-cell; vertical-align: middle;padding: 1px; "><span>Siège :</span><br><span>Libre</span></div></div><div style="text-align:center;width: 95px;float:left;display: table;height: 46px;margin-left: 9px;"><div style="display: table-cell; vertical-align: middle;padding: 1px; "><span>CAT :</span><br><span>Standard</span></div></div><div style="text-align:center;width: 95px;float:left;display: table;height: 46px;margin-left: 9px;"><div style=" vertical-align: middle; display: table-cell; "><span>Prix :</span><br><span>Rs 500</span></div></div></div></div></div></div></body></html>`;
        setrawHtml(html);


    }

    const createMarkup = (html) => {
        // var html = physicalHtml;
        return {__html: html};
    }

    const ticketChanged = (e) => {
        setSelectedTicket(e.target.value);

        TicketTemplatesService.getEventTemplate(e.target.value)
        .then(res => {
            console.log({res});
            setTicketConfig(res.data);
        })
        .catch(err => {
            console.log({err});
        });
    }

    const updateConfig = (value, key) => {
        var tempTicketConfig = ticketConfig;

        switch (key) {
            case "showPresentText":
                tempTicketConfig.showPresentText = value;
                break;
            case "overPresentText":
                tempTicketConfig.overPresentText = value;
                break;
            case "showEventName":
                tempTicketConfig.showEventName = value;
                break;
            case "overEventName":
                tempTicketConfig.overEventName = value;
                break;
            case "showEventLocation":
                tempTicketConfig.showEventLocation = value;
                break;
            case "overEventLocation":
                tempTicketConfig.overEventLocation = value;
                break;
            case "showEventDateTime":
                tempTicketConfig.showEventDateTime = value;
                break;
            case "overEventDateTime":
                tempTicketConfig.overEventDateTime = value;
                break;
            case "showCustomerName":
                tempTicketConfig.showCustomerName = value;
                break;
            case "overCustomerName":
                tempTicketConfig.overCustomerName = value;
                break;
            case "showSeatLabel":
                tempTicketConfig.showSeatLabel = value;
                break;
            case "overSeatLabel":
                tempTicketConfig.overSeatLabel = value;
                break;
            case "showTicketCat":
                tempTicketConfig.showTicketCat = value;
                break;
            case "overTicketCat":
                tempTicketConfig.overTicketCat = value;
                break;
            case "showTicketPrice":
                tempTicketConfig.showTicketPrice = value;
                break;
            case "overTicketPrice":
                tempTicketConfig.overTicketPrice = value;
                break;
            case "showOrderDateTime":
                tempTicketConfig.showOrderDateTime = value;
                break;
            case "showQRCode":
                tempTicketConfig.showQRCode = value;
                break;
            case "overTicketNote":
                tempTicketConfig.overTicketNote = value;
                break;
        
            default:
                break;
        }

        setTicketConfig(tempTicketConfig);
    }

    return (
        <div className="page-wrapper">
            <div className="row">
                <div className="col heading-h1-wrapper heading-h1-wrapper-onsiteselling">
                    <h1>Ticket Templates</h1>
                    <Select 
                    options={events} 
                    placeholder="Select an Event" 
                    onChange={(option) => eventChanged(option)}
                    />
                </div>
                <hr />
            </div>

            {selectedEvent && (
            <div className="container">
                <div className="row">
                    <div className="col">
                        <div className="event-details-wrapper">
                            <h2>{selectedEvent.label}</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col tickets-heading">
                        Physical Ticket Template
                    </div>
                </div>

                 <div className="row">
                    <div className="col">
                        <div className="form-group row">
                            <label for="inputPassword" className="col-sm-2 col-form-label">Select a Ticket</label>
                            <div className="col-sm-10">
                                <select className="form-control form-control-select" value={selectedTicket} onChange={(e) => ticketChanged(e)}>
                                    <option value="0">Select a Ticket</option>
                                    {eventTickets.length>0 && eventTickets.map((ticket, index) => (
                                        <option key={index} value={ticket.id}>{ticket.label}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {selectedTicket!=null &&      
                <>          
                <div className="row">
                    <div className="col tickets-heading">
                        Template Config
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="form-group row">
                                <label for="inputPassword" className="col-sm-5 col-form-label fw-bold">Show Presents Text</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showPresentText} onChange={(e) => updateConfig(e.target.value, "showPresentText")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Ovewrite Presents Text</label>
                                <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Ovewrite Presents Text" value={ticketConfig.overPresentText} onChange={(e) => updateConfig(e.target.value, "overPresentText")}></input>
                                </div>
                            </div>

                            
                            <div className="form-group row mt-6">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Show Event Name</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showEventName} onChange={(e) => updateConfig(e.target.value, "showEventName")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Ovewrite Event Name</label>
                                <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Ovewrite Event Name" value={ticketConfig.overEventName} onChange={(e) => updateConfig(e.target.value, "overEventName")}></input>
                                </div>
                            </div>

                            <div className="form-group row mt-6">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Show Event Location</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showEventLocation} onChange={(e) => updateConfig(e.target.value, "showEventLocation")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Ovewrite Event Location</label>
                                <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Ovewrite Event Location" value={ticketConfig.overEventLocation} onChange={(e) => updateConfig(e.target.value, "overEventLocation")}></input>
                                </div>
                            </div>

                            <div className="form-group row mt-6">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Show Event Date/Time</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showEventDateTime} onChange={(e) => updateConfig(e.target.value, "showEventDateTime")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Ovewrite Event Date Time</label>
                                <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Ovewrite Event Date Time" value={ticketConfig.overEventDateTime} onChange={(e) => updateConfig(e.target.value, "overEventDateTime")}></input>
                                </div>
                            </div>

                            <div className="form-group row mt-6">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Show Customer Name</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showCustomerName} onChange={(e) => updateConfig(e.target.value, "showCustomerName")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Ovewrite Customer Name</label>
                                <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Not Recommended to Ovewrite Customer Name" value={ticketConfig.overCustomerName} onChange={(e) => updateConfig(e.target.value, "overCustomerName")}></input>
                                </div>
                            </div>
                        </div>
                         <div className="col" style={{maxWidth: "100px"}}></div>
                        <div className="col">
                            <div className="form-group row">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Show Seat Label</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showSeatLabel} onChange={(e) => updateConfig(e.target.value, "showSeatLabel")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Ovewrite Seat Label</label>
                                <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Not Recommended to Ovewrite Seat Label" value={ticketConfig.overSeatLabel} onChange={(e) => updateConfig(e.target.value, "overSeatLabel")}></input>
                                </div>
                            </div>

                            <div className="form-group row mt-6">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Show Ticket Category</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showTicketCat} onChange={(e) => updateConfig(e.target.value, "showTicketCat")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Ovewrite Ticket Category</label>
                                <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Ovewrite Ticket Category" value={ticketConfig.overTicketCat} onChange={(e) => updateConfig(e.target.value, "overTicketCat")}></input>
                                </div>
                            </div>

                            <div className="form-group row mt-6">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Show Ticket Pice</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showTicketPrice} onChange={(e) => updateConfig(e.target.value, "showTicketPrice")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row mt-2">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Ovewrite Ticket Price</label>
                                <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="Not Recommended to Ovewrite Ticket Price" value={ticketConfig.overTicketPrice} onChange={(e) => updateConfig(e.target.value, "overTicketPrice")}></input>
                                </div>
                            </div>

                            <div className="form-group row mt-6">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Show Order Date/Time</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showOrderDateTime} onChange={(e) => updateConfig(e.target.value, "showOrderDateTime")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-group row mt-6">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Show QR Code</label>
                                <div className="col-sm-7">
                                    <select className="form-control form-control-select" value={ticketConfig.showQRCode} onChange={(e) => updateConfig(e.target.value, "showQRCode")}>
                                        <option value="yes">Yes</option>
                                        <option value="no">No</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-group row mt-6">
                                <label for="inputPassword" className="col-md-5 col-form-label fw-bold">Add Ticket Note</label>
                                <div className="col-sm-7">
                                <input type="text" className="form-control" placeholder="" value={ticketConfig.overTicketNote} onChange={(e) => updateConfig(e.target.value, "overTicketNote")}></input>
                                </div>
                            </div>

                            <div className="form-group row mt-6">
                                <button type="button" className="btn btn-success btn-blue bg-blue-500 hover:bg-blue-300">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
                </>
                }

                <div className="row mt-10">
                    <div className="col phy-ticket-container" dangerouslySetInnerHTML = {createMarkup(rawHtml)}>
                        
                    </div>
                </div>
            </div>
            )}
        </div>
    );
}

export default TicketTemplates;